import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import DynamicForm from "f1-dynamic-form-react";
import Loader from "./../../components/loader/loader";
import { customValidators, Account_Inventory_Data } from "./../formData";
import { format } from "date-fns";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useNavigate } from "react-router-dom";
import { post } from "./../../api/api";
import { ApiUrls } from "./../../api/baseURL";
import { getAllOfTable } from "../../offlineManager/localbase";
import useOnlineStatus from "../../useOnlineStatus";
import { metaDataConstants } from "../../utils/Constants/constants-en";
import { getDateWithFormat } from "../../utils/utils";

const AccountBarcodeReader = () => {
  let dyFormRef = useRef();
  let naviagte = useNavigate();
  const isOnline = useOnlineStatus();

  const [activateLoader, setActivateLoader] = useState(false);
  const [candidateDetail, setCandidateDetail] = useState(
    Account_Inventory_Data
  );
  const [inventoryType, setInventoryType] = useState("")
  const [show, setShow] = useState(false);
  const [serverityStatus, setServerityStatus] = useState("");
  const [message, setMessage] = useState("");
  const [accountData, setAccountData] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [current, setCurrent] = useState({
    inventorydate: null,
    account: null,
    accountId: null,
    storageArea: null,
    inventoryduedate: null,
    inventorycounted: null,
    isCategoryBased: false,
  });

  const [inventoryCheckAccountId, setInventoryCheckAccountId] = useState(null);
  const [state, setState] = useState({
    activateLoader: false,
    show: false,
    serverityStatus: "",
    message: "",
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setState({ ...state, show: false });
    setShow(false)
  };

  const getDropdownData = (optionsArr, key, label, id) => {
    const arr = optionsArr?.map((item) => {
      return {
        key: id ? item[id] : item[key],
        label: item[label]?.charAt(0)?.toUpperCase() + item[label]?.slice(1),
        value: id ? item[id] : item[key],
      };
    });
    arr.unshift({ key: -1, label: "Select", value: -1 });
    return arr;
  };
  useEffect(() => {
    disableSubmitButton()
  }, [current])

  useEffect(() => {
    getAccount();
  }, []);

  const getAccount = async () => {
    return new Promise((resolve, reject) => {
      getAllOfTable('AccountWiseAccountDetails').then((res) => {
        resolve(res[0].accountWiseAccountDetails)
        console.log(res[0].accountWiseAccountDetails)
        setAccountData([{ accountId: -1, label: "Select", value: -1 }, ...res[0].accountWiseAccountDetails])
        const data = res[0].accountWiseAccountDetails.filter(i => i.status != "Posted");

        if (data.length > 0) {
          setInventoryCheckAccountId(data[0].id);
        } else {
          setInventoryCheckAccountId(null);
          setShow(true)
          setServerityStatus("info")
          setMessage(metaDataConstants.accountNotForUser);
          return
        }
        const copyFormData = [...candidateDetail];
        copyFormData[1].options = getDropdownData(
          data,
          "accountId",
          "accountName",
          "id"
        );

        if (data[0].inventoryCountTypeMetadataName === "Category Based") {
          const dateFormate = metaDataConstants.yearMonthDateFormat;
          const minDate = getDateWithFormat(dateFormate);
          copyFormData[2].disabled = true;
          copyFormData[2].validators = [];

          setCandidateDetail(copyFormData)
          setCurrent({ ...current, account: data.length > 1 ? -1 : data[0].accountId, accountId: data.length > 1 ? -1 : data[0]?.id, storageArea: "", inventorydate: minDate, inventoryduedate: data[0].dueDate?.slice(0, 10), inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}` })
        }
        else {
          copyFormData[2].disabled = false;
          copyFormData[2].validators = [{ name: "required", value: true, validationMessage: metaDataConstants.storageAreaRequired },];
          setCandidateDetail(copyFormData)
          getStorage(data.length > 1 ? -1 : data[0].accountId, data.length > 1 ? -1 : data[0]?.id, data[0].dueDate);
        }

      }).catch((err) => reject(false))
    })

  };

  const getStorage = async (accounId, inventoryCheckAccountId, dueDate) => {
    setActivateLoader(true)
    if (isOnline) {
      if (accounId != -1) {
        const payload = {
          InventoryCheckAccountId: inventoryCheckAccountId,
          AccountId: accounId,
          IsActive: 1,
          SkipProductIds: '',
          take: 1000,
          skip: 0,
          page: 1,
          pageSize: 1000,
        };
        setActivateLoader(true);
        const response = await post(ApiUrls().PRODUCT_BY_INVENTORY_COUNT, payload, 'application/x-www-form-urlencoded; charset=UTF-8').catch(
          function (error) {
            // Handle errors here
            setActivateLoader(false);
            console.error("Error:", error);
          }
        );

        if (response?.status === 200) {
          setActivateLoader(false);
          console.log(response?.data);
          if (response?.data?.result.length != 0) {
            const uniqueRecords = response.data.result.reduce((acc, curr) => {
              const exists = acc.some(item => item.locationStorageId === curr.locationStorageId && item.storageName === curr.storageName);
              if (!exists) {
                acc.push(curr);
              }

              return acc;
            }, []);
            const copyFormData = [...candidateDetail];
            copyFormData[2].options = getDropdownData(
              uniqueRecords,
              "locationStorageId",
              "storageName"
            );

            setCandidateDetail(copyFormData)
            const dateFormate = metaDataConstants.yearMonthDateFormat;
            const minDate = getDateWithFormat(dateFormate);

            setCurrent({ ...current, account: accounId, accountId: inventoryCheckAccountId, inventorydate: minDate, inventoryduedate: dueDate?.slice(0, 10), storageArea: uniqueRecords.length > 1 ? -1 : uniqueRecords[0]?.locationStorageId, inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}`, isCategoryBased: false })
            setActivateLoader(false)
          } else {
            console.log(metaDataConstants.noStorageArea)
          }
        } else {
          setActivateLoader(false);
        }
      } else {
        const copyFormData = [...candidateDetail];
        copyFormData[2].options = [{ key: -1, label: "Select", value: -1 }]
        setCandidateDetail(copyFormData);

        const dateFormate = metaDataConstants.yearMonthDateFormat;
        const minDate = getDateWithFormat(dateFormate);
        setCurrent({ ...current, account: accounId, accountId: inventoryCheckAccountId, inventorydate: minDate, inventoryduedate: dueDate?.slice(0, 10), storageArea: -1, inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}`, isCategoryBased: false })
        setActivateLoader(false)
      }
    } else {

      return new Promise((resolve, reject) => {
        getAllOfTable('PhysicalInventoryDetails').then((res) => {
          if (accounId != -1) {
            resolve(res[0].physicalInventoryDetails)
            const data = res[0].physicalInventoryDetails;
            const result = data.filter((el) => el.id == inventoryCheckAccountId)
            const uniqueRecords = result.reduce((acc, curr) => {
              const exists = acc.some(item => item.locationStorageId === curr.locationStorageId && item.storageName === curr.storageName);
              if (!exists) {
                acc.push(curr);
              }

              return acc;
            }, []);
            const copyFormData = [...candidateDetail];
            copyFormData[2].options = getDropdownData(
              uniqueRecords,
              "locationStorageId",
              "storageName"
            );
            setCandidateDetail(copyFormData)
            const dateFormate = metaDataConstants.yearMonthDateFormat;
            const minDate = getDateWithFormat(dateFormate);
            setCurrent({ ...current, account: accounId, accountId: inventoryCheckAccountId, inventorydate: minDate, inventoryduedate: dueDate?.slice(0, 10), storageArea: uniqueRecords.length > 1 ? -1 : uniqueRecords[0]?.locationStorageId, inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}`, isCategoryBased: false })
            setActivateLoader(false)
          } else {
            const copyFormData = [...candidateDetail];
            copyFormData[2].options = [{ key: -1, label: "Select", value: -1 }]
            setCandidateDetail(copyFormData);
            const dateFormate = metaDataConstants.yearMonthDateFormat;
            const minDate = getDateWithFormat(dateFormate);
            setCurrent({ ...current, account: accounId, accountId: inventoryCheckAccountId, inventorydate: minDate, inventoryduedate: dueDate?.slice(0, 10), storageArea: -1, inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}`, isCategoryBased: false })
            setActivateLoader(false)
          }
        }).catch((err) => {
          reject(false)
          setActivateLoader(false)
        })
      })
    }
  };
  const onSubmitHandler = async (model) => {
    if (model.accountId != null && model.accountId !== "") {
      delete model.errors.accountId;
    }
    if (model.storageArea != null && model.storageArea !== "") {
      delete model.errors.storageArea
    }
    if (
      (!model.isValidForm && Object.keys(model.errors).length > 0) ||
      Object.keys(model.errors).length > 0
    ) {
      return false;
    }
    setActivateLoader(true);
    localStorage.setItem("accountId", model.account);
    localStorage.setItem("accountinventoryduedate", model.inventoryduedate);
    localStorage.setItem("inventoryCheckAccountId", inventoryCheckAccountId);
    localStorage.setItem("accountlocationStorageId", model.storageArea)
    localStorage.setItem("inventoryType", inventoryType)
    setActivateLoader(false);
    naviagte(`/account_product_detail`);
  };

  const onChangeHandler = async (event, key, model) => {
    if (key === "accountId") {
      const id = event.target.value;
      const res = accountData?.filter((ele) => ele.id == id);
      setInventoryCheckAccountId(res[0].id);
      const copyFormData = [...candidateDetail];
      setInventoryType(res[0].inventoryCountTypeMetadataName)
      if (res[0].inventoryCountTypeMetadataName === "Category Based") {
        const dateFormate = metaDataConstants.yearMonthDateFormat;
        const minDate = getDateWithFormat(dateFormate);
        copyFormData[2].disabled = true;
        copyFormData[2].validators = [];
        setCandidateDetail(copyFormData)
        setCurrent({ ...current, account: res[0].accountId, accountId: res[0].id, inventorydate: minDate, storageArea: "", inventoryduedate: res[0].dueDate?.slice(0, 10), inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}`, isCategoryBased: true })
      } else {
        copyFormData[2].disabled = false;
        copyFormData[2].validators = [{ name: "required", value: true, validationMessage: metaDataConstants.storageAreaRequired },];
        setCandidateDetail(copyFormData)
        getStorage(res[0].accountId, res[0].id, res[0].dueDate);
      }
    }
    if (key === "storageArea") {
      setCurrent((prev) => ({
        ...prev,
        storageArea: event.target.value,
      }));
    }
  };
  const disableSubmitButton = () => {
    console.log(current);
    if (current.accountId != '-1' && (current.storageArea != '-1' || current.isCategoryBased)) {
      setDisableSubmit(false)
      return
    }
    setDisableSubmit(true)
  }

  return (
    <>
      <Snackbar
        open={show}
        autoHideDuration={2000}
        onClose={() =>
          handleClose({
            vertical: "bottom",
            horizontal: "right",
          })
        }
      >
        <Alert severity={serverityStatus}>{message}</Alert>
      </Snackbar>
      <div className="container containerMainDiv">
        <div className="contentdivBg pt-0">
          <div className="divRound">
            {localStorage.getItem("permission") == "Edit" ? (
              <div>
                <div className="clearfix"></div>

                <div className="formData mt-3">
                  <Grid
                    className="activiPad0"
                    container
                    columns={{ xs: 4, md: 12 }}
                  >
                    <Grid item xs={12} md={9} className="leftCol">
                      <DynamicForm
                        onRef={(ref) => {
                          dyFormRef.current = ref;
                        }}
                        key={1}
                        className="dynamicForm"
                        title={metaDataConstants.barcodeInvDetails}
                        design="bootrstap"
                        model={candidateDetail}
                        defaultValues={current}
                        materialOutline={false}
                        customValidators={customValidators}
                        showAstersikOnRequiredFields={true}
                        onSubmit={(model) => onSubmitHandler(model)}
                        disableSubmitOnInValid={disableSubmit}
                        onChange={(event, key, model) =>
                          onChangeHandler(event, key, model)
                        }
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>
            ) : (
              <p className="permission">
                {metaDataConstants.noPermissionForInv}
              </p>
            )}
          </div>
        </div>
      </div>
      <div></div> <Loader active={activateLoader} />
    </>
  );
};
export default AccountBarcodeReader;
